export const sitesForCompany = (sites, companyId) => {
  if (!companyId) return []
  return sites.filter((site) => site.company_id === companyId)
}

export const posForSite = (posList, siteId) => {
  if (!siteId) return []
  return posList.filter((pos) => pos.site_id === siteId)
}

export const posForCompany = (posList, sites, companyId) => {
  const siteIds = new Set(sitesForCompany(sites, companyId).map((site) => site.site_id))
  return posList.filter((pos) => siteIds.has(pos.site_id))
}

export const formatScopedPosLabel = (pos, sites, includeSite) => {
  const posLabel = pos.pos_label || pos.pos_serial || '-'
  if (!includeSite) return posLabel
  const siteName = pos.site_name || sites.find((site) => site.site_id === pos.site_id)?.name
  return siteName ? `${posLabel} (${siteName})` : posLabel
}

export const buildExportScopePayload = ({ companyId, scopeLevel, siteIds = [], posId = '' }) => ({
  company_id: companyId,
  site_ids: scopeLevel === 'sites' ? siteIds : [],
  pos_ids: scopeLevel === 'pos' && posId ? [posId] : []
})

export const groupExportPosBySite = (posList, sites) => {
  const posBySite = new Map()
  for (const pos of posList) {
    if (!pos?.site_id) continue
    const current = posBySite.get(pos.site_id) || []
    current.push(pos)
    posBySite.set(pos.site_id, current)
  }
  return sites
    .filter((site) => posBySite.has(site.site_id))
    .map((site) => ({ site, pos: posBySite.get(site.site_id) }))
}

export const filterExportPosGroups = (groups, query) => {
  const normalizedQuery = String(query || '').trim().toLowerCase()
  if (!normalizedQuery) return groups
  const queryTerms = normalizedQuery.split(/\s+/)
  const filterGroups = (matches) => groups.flatMap((group) => {
    const siteName = String(group.site?.name || '').toLowerCase()
    const matchingPos = group.pos.filter((pos) => {
      const searchableText = [siteName, pos.name, pos.pos_label, pos.pos_serial]
        .map((value) => String(value || '').toLowerCase())
        .join(' ')
      return matches(searchableText)
    })
    return matchingPos.length ? [{ ...group, pos: matchingPos }] : []
  })
  const phraseMatches = filterGroups((searchableText) => searchableText.includes(normalizedQuery))
  return phraseMatches.length
    ? phraseMatches
    : filterGroups((searchableText) => queryTerms.every((term) => searchableText.includes(term)))
}

export const matchesExportScope = (artifact, siteIds = [], posIds = [], posOptions = []) => {
  const selectedSiteIds = Array.isArray(siteIds) ? siteIds : (siteIds ? [siteIds] : [])
  if (selectedSiteIds.length && artifact.site_id && !selectedSiteIds.includes(artifact.site_id)) return false
  if (!posIds.length) return true
  const selectedPosSiteIds = new Set(
    posOptions
      .filter((pos) => posIds.includes(pos.pos_id))
      .map((pos) => pos.site_id)
      .filter(Boolean)
  )
  if (artifact.site_id && !selectedPosSiteIds.has(artifact.site_id)) return false
  return !artifact.pos_id || posIds.includes(artifact.pos_id)
}
